import { Title } from "@angular/platform-browser";

export const environmenAchievement = {
    hardy:{
        name:"txtHardyName",
        title: "txtHardyTitle",
        icon:'handyman',
        account: 1800,
        count: 0,
        value: 0,
        isSnackBar: true,
        class: 'cl-hardy',
        point: 0
    },
    stable:{
        name:"txtStableName",
        title: "txtStableTitle",
        icon:'video_stable',
        account: 3,
        counter: 0, // increment коли правильна відповідь, 0 коли не правильна
        count: 0,// ++
        value: 0, // 100 // (counter / account) * 100
        isSnackBar: true, // false - коли value = 100
        class: 'cl-stable',
        point: 0
    },
    master:{
        name:"txtMasterName",
        title: "txtMasterTitle",
        icon:'school',
        account: 80,
        count: 0, // якщо в кінці гри 80 набрали ++ 
        value: 0, // переводимо на 100 
        isSnackBar: true, // false - коли value = 100
        class: 'cl-master',
        point: 0
    },
    champion:{
        name:"txtChampionName",
        title: "txtChampionTitle",
        icon:'editor_choice',
        account: 3,
        count: 0, // залежить від мастера "master.count % account === 0 -> ++", 
        value: 0, // переводимо на 100 
        isSnackBar: true, // false - коли value = 100
        class: 'cl-champion',
        idDependence: true,
        dependenceType: 'master',
        point: 0
    },
    loser:{
        name:'Жолтая карточка',
        title: 'Если набрал 0 и меньше баллов',
        icon: 'thumb_down',
        account: 0,
        count: 0,
        value: 0,
        isSnackBar: true,
        class: 'cl-hardy',
    }
}